import { combineReducers } from 'redux';
import agentDetailsReducer from './agentDetails.reducers';

const reducer = combineReducers(Object.assign({
    agentDetails: agentDetailsReducer
}));

export default reducer;